'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function either(first, second, arg) {
  return Boolean(first(arg) || second(arg));
}

/**
 * Returns true if the results of `arg` applied to either `first` or `second`
 * are truthy.
 *
 * @example
 * const oneOrTwo = either(
 *   n => n === 1,
 *   n => n === 2
 * );
 *
 * oneOrTwo(1) === true;
 * oneOrTwo(2) === true;
 * oneOrTwo(3) === false;
 *
 * @param  {Function} first
 * @param  {Function} second
 * @param  {any} subject
 * @return {boolean}
 */
exports.default = (0, _curry2.default)(either);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/either.js
// module id = 347
// module chunks = 0 1